/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Midi_TitleInputs */

const en_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIDI Configuration`)
};

const fr_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration MIDI`)
};

const de_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIDI-Konfiguration`)
};

const it_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurazione MIDI`)
};

const ru_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка MIDI`)
};

const es_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración MIDI`)
};

const zh_cn2_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIDI 配置`)
};

const ja_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIDI設定`)
};

const hi_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIDI कॉन्फ़िगरेशन`)
};

const pt_pt2_options_adr_midi_title = /** @type {(inputs: Options_Adr_Midi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração MIDI`)
};

/**
* | output |
* | --- |
* | "MIDI Configuration" |
*
* @param {Options_Adr_Midi_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_midi_title = /** @type {((inputs?: Options_Adr_Midi_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Midi_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_midi_title(inputs)
	if (locale === "de") return de_options_adr_midi_title(inputs)
	if (locale === "it") return it_options_adr_midi_title(inputs)
	if (locale === "ru") return ru_options_adr_midi_title(inputs)
	if (locale === "es") return es_options_adr_midi_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_midi_title(inputs)
	if (locale === "ja") return ja_options_adr_midi_title(inputs)
	if (locale === "hi") return hi_options_adr_midi_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_midi_title(inputs)
	return en_options_adr_midi_title(inputs)
});